import XLS from './XLS';

export default XLS;
